//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "PdfThumbnail",
  props: {
    pageNumber: {
      type: Number,
      required: true
    },
    currentPage: {
      type: Number,
      default: null
    },
    include: {
      type: Boolean,
      required: true
    },
    rotation: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      hidden: false
    };
  },
  computed: {
    isHorizontal() {
      return Number(this.rotation) % 180 !== 0;
    }
  },
  methods: {
    handlePreview() {
      this.$emit("preview");
    },
    handleHidden() {
      this.hidden = !this.hidden;
      this.$emit("hide");
    }
  }
});